import { Navigate, Outlet } from "react-router-dom";
import { getAdminPassword } from "@/lib/auth/storage";

export function AdminAuthGuard() {
  if (!getAdminPassword()) {
    return <Navigate to="/admin/login" replace />;
  }
  return <Outlet />;
}
